import React, { FunctionComponent } from "react";

import { MODAL_ROOT_ID } from "UI/UI.React/constants";
import { PopupComponent, PopupComponentProps } from "../PopupComponent";

export type PopupProps = Omit<PopupComponentProps, "rootId">;

/** Komponenta popupu */
export const Popup: FunctionComponent<PopupProps> = ({
    triggerElement,
    contextElement,
    requestedPosition,
    opened = false,
    children,
    onMouseLeave,
    onMouseEnter,
    height,
    width,
}) => {
    return (<PopupComponent { ...{ triggerElement, contextElement, opened, children, onMouseLeave, onMouseEnter, requestedPosition, height, width } } rootId={MODAL_ROOT_ID} />);
};
